import React from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { TextAreaProps } from "./types";
import Label from "./label";
import styles from "./styles";

const TextArea = (props: TextAreaProps) => {
    const {
        name,
        label,
        cssName,
        labelCssName,
        fieldOptions = {},
        customValidationMessage,
        placeHolder,
        ...rest
    } = props;

    const { register, formState: { errors } } = useFormContext();

    //Note label comes after input but to BS floating labels

    const onIn = (event: any) => {
        event.target.parentElement.dataset.value = event.target.value;
    }

    return (<div className={cssName}>
        <textarea
            id={name}
            rows={1}
            onInput={onIn}
            {...register(name, fieldOptions)}
            {...rest}
            className={styles.elements.input}
            placeholder={placeHolder ?? label} />

        <Label htmlFor={name} text={label} cssName={labelCssName} />

        <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <p className="error">{message}</p>}
        />
    </div>);
}

export default TextArea;